// =====================================================
// EC Gift Manager - Auto-add gifts to cart
// Gratis Alepposeife ab 3 Flaschen Sköl
// Gratis Blütenhonig 500g ab 120€ Einkaufswert
// =====================================================
(function() {
    'use strict';

    // --- Configuration ---
    var EC_GIFT_CONFIG = {
        skoel_product_ids: [9160104313173, 9160096121173, 8028212068658, 9164713525589],
        // Gratis Alepposeife (0€ product)
        aleppo_variant_id: 55034917912917,
        aleppo_product_id: 11622664864085,
        // Gratis Blütenhonig 500g (0€ product)
        honig_variant_id: 55034908311893,
        honig_product_id: 11622658605397,
        honig_threshold: 120,
        skoel_min_qty: 3,
        // All gift variant IDs (for hiding quantity controls)
        gift_variant_ids: [55034917912917, 55034908311893]
    };

    var ec_gift_busy = false;

    // --- Fetch cart ---
    function ec_fetchCart() {
        return fetch('/cart.js').then(function(r) { return r.json(); });
    }

    // --- Main gift logic ---
    async function ec_processGifts() {
        if (ec_gift_busy) return;
        ec_gift_busy = true;

        try {
            var cart = await ec_fetchCart();
            var items = cart.items;
            var cfg = EC_GIFT_CONFIG;

            // Count total Sköl quantity
            var skoel_qty = 0;
            for (var i = 0; i < items.length; i++) {
                if (cfg.skoel_product_ids.indexOf(items[i].product_id) !== -1) {
                    skoel_qty += items[i].quantity;
                }
            }

            // Cart total excluding gift products
            var cart_total_excl = 0;
            for (var j = 0; j < items.length; j++) {
                if (items[j].product_id !== cfg.aleppo_product_id && items[j].product_id !== cfg.honig_product_id) {
                    cart_total_excl += (items[j].original_line_price / 100);
                }
            }

            // Check if gifts are in cart
            var aleppo_in_cart = null;
            var honig_in_cart = null;
            for (var k = 0; k < items.length; k++) {
                if (items[k].id === cfg.aleppo_variant_id) aleppo_in_cart = items[k];
                if (items[k].id === cfg.honig_variant_id) honig_in_cart = items[k];
            }

            var needs_aleppo = skoel_qty >= cfg.skoel_min_qty;
            var needs_honig = cart_total_excl >= cfg.honig_threshold;

            console.log('[EC Gift] Sköl qty:', skoel_qty, '| Cart excl gifts:', cart_total_excl.toFixed(2) + '€',
                '| Needs Aleppo:', needs_aleppo, '| Needs Honig:', needs_honig,
                '| Aleppo in cart:', !!aleppo_in_cart, '| Honig in cart:', !!honig_in_cart);

            var items_to_add = [];
            var updates_to_make = {};
            var changed = false;

            // Alepposeife logic
            if (needs_aleppo && !aleppo_in_cart) {
                items_to_add.push({ id: cfg.aleppo_variant_id, quantity: 1 });
                console.log('[EC Gift] -> Adding Gratis Alepposeife');
            } else if (!needs_aleppo && aleppo_in_cart) {
                updates_to_make[cfg.aleppo_variant_id] = 0;
                console.log('[EC Gift] -> Removing Alepposeife');
            } else if (aleppo_in_cart && aleppo_in_cart.quantity > 1) {
                updates_to_make[cfg.aleppo_variant_id] = 1;
                console.log('[EC Gift] -> Limiting Alepposeife to 1');
            }

            // Honig logic
            if (needs_honig && !honig_in_cart) {
                items_to_add.push({ id: cfg.honig_variant_id, quantity: 1 });
                console.log('[EC Gift] -> Adding Gratis Honig');
            } else if (!needs_honig && honig_in_cart) {
                updates_to_make[cfg.honig_variant_id] = 0;
                console.log('[EC Gift] -> Removing Honig');
            } else if (honig_in_cart && honig_in_cart.quantity > 1) {
                updates_to_make[cfg.honig_variant_id] = 1;
                console.log('[EC Gift] -> Limiting Honig to 1');
            }

            // Execute updates (removals/limits)
            if (Object.keys(updates_to_make).length > 0) {
                await fetch(window.Shopify.routes.root + 'cart/update.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ updates: updates_to_make })
                });
                changed = true;
            }

            // Execute additions
            if (items_to_add.length > 0) {
                await fetch(window.Shopify.routes.root + 'cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ items: items_to_add })
                });
                changed = true;
            }

            if (changed) {
                console.log('[EC Gift] Cart updated, reloading...');
                localStorage.setItem("drawer", "true");
                window.location.reload(true);
            }
        } catch (err) {
            console.error('[EC Gift] Error:', err);
        } finally {
            ec_gift_busy = false;
        }
    }

    // --- Listen for cart_changed events (fired by CU_script.js or self) ---
    window.addEventListener("cart_changed", function() {
        ec_processGifts();
    });

    // --- Own cart observer (in case CU_script.js doesn't load or fire) ---
    function ec_emitCartChanged() {
        ec_fetchCart().then(function(cart) {
            window.dispatchEvent(new CustomEvent("ec_cart_updated", { detail: cart }));
        });
    }

    window.addEventListener("ec_cart_updated", function() {
        ec_processGifts();
    });

    // Observe cart API calls
    try {
        var ec_observer = new PerformanceObserver(function(list) {
            list.getEntries().forEach(function(entry) {
                var isValid = ['xmlhttprequest', 'fetch'].indexOf(entry.initiatorType) !== -1;
                var isCart = /\/cart\//.test(entry.name);
                if (isValid && isCart) {
                    // Small delay to let the cart API finish
                    setTimeout(ec_emitCartChanged, 300);
                }
            });
        });
        ec_observer.observe({ entryTypes: ["resource"] });
    } catch(e) {
        console.warn('[EC Gift] PerformanceObserver not supported');
    }

    // --- Also run on initial page load to catch existing cart state ---
    if (document.readyState === 'complete' || document.readyState === 'interactive') {
        setTimeout(ec_processGifts, 1500);
    } else {
        document.addEventListener('DOMContentLoaded', function() {
            setTimeout(ec_processGifts, 1500);
        });
    }

    // --- Hide quantity controls for gift products in cart sidebar & cart page ---
    function ec_hideGiftQtyControls() {
        var cfg = EC_GIFT_CONFIG;
        // Target cart items by data-variant-id or variant key attribute
        cfg.gift_variant_ids.forEach(function(vid) {
            // Cart sidebar (halo-side-cart): find items with this variant
            var selectors = [
                '[data-variant-id="' + vid + '"]',
                '[data-cart-item-key*="' + vid + '"]',
                'a[href*="variant=' + vid + '"]'
            ];
            selectors.forEach(function(sel) {
                var els = document.querySelectorAll(sel);
                els.forEach(function(el) {
                    // Walk up to the cart item container
                    var cartItem = el.closest('.previewCart__item, .cart__row, .cart-item, .item--loadout, [data-cart-item], .mini-cart-item, .cart__item, .cart_item, tr.line-item');
                    if (cartItem) {
                        // Hide qty controls within this item
                        var qtyEls = cartItem.querySelectorAll('.quantity, .qty, .cart-qty, input[name="updates[]"], .quantity__selector, .quantity-selector, .ajaxcart__qty, .js-qty, .cart__quantity-selector, .quantity-wrapper, .quantity__wrapper, .item--qty, .previewCart__qty');
                        qtyEls.forEach(function(q) {
                            q.style.display = 'none';
                        });
                        // Also hide remove/delete button for gift items
                        var removeEls = cartItem.querySelectorAll('.previewCart__remove, .cart__remove, .remove, .cart-item__remove, a[href*="/cart/change"]');
                        removeEls.forEach(function(r) {
                            r.style.display = 'none';
                        });
                        // Add a "GRATIS" badge
                        if (!cartItem.querySelector('.ec-gift-badge')) {
                            var badge = document.createElement('span');
                            badge.className = 'ec-gift-badge';
                            badge.textContent = 'GRATIS 🎁';
                            badge.style.cssText = 'display:inline-block;background:#2e7d32;color:#fff;padding:2px 8px;border-radius:4px;font-size:11px;font-weight:700;margin-top:4px;letter-spacing:0.5px;';
                            // Insert after title or at the end of the item info area
                            var titleEl = cartItem.querySelector('.previewCart__name, .cart__product-name, .cart-item__name, .product-title, .item--title');
                            if (titleEl) {
                                titleEl.parentNode.insertBefore(badge, titleEl.nextSibling);
                            } else {
                                cartItem.appendChild(badge);
                            }
                        }
                    }
                });
            });
        });
    }

    // Run hide controls after cart renders & on mutations
    function ec_observeCartDOM() {
        ec_hideGiftQtyControls();
        // Also watch for DOM changes (cart drawer opening, AJAX cart updates)
        var cartContainers = document.querySelectorAll('#halo-cart-sidebar, .cart, #cart, .mini-cart, .cart-drawer, [data-cart-items]');
        cartContainers.forEach(function(container) {
            var mo = new MutationObserver(function() {
                setTimeout(ec_hideGiftQtyControls, 200);
            });
            mo.observe(container, { childList: true, subtree: true });
        });
    }

    if (document.readyState === 'complete' || document.readyState === 'interactive') {
        setTimeout(ec_observeCartDOM, 2000);
    } else {
        document.addEventListener('DOMContentLoaded', function() {
            setTimeout(ec_observeCartDOM, 2000);
        });
    }

    console.log('[EC Gift] Gift manager loaded. Aleppo ab 3 Sköl, Honig ab 120€');
})(); 